/**
 * Perguntas Bônus (versão real — sobre o DESFECHO do campeonato, não
 * perguntas livres por rodada). O ADM escolhe quais das 4 perguntas fixas
 * ficam ativas, define quantos pontos vale cada uma e um prazo ÚNICO de
 * resposta pra todas. Cada participante responde escolhendo um CLUBE da
 * competição (não texto livre — permite conferência automática depois).
 * A pontuação é aplicada automaticamente depois que o campeonato acaba de
 * verdade (última rodada encerrada) comparando a resposta com a
 * classificação final real.
 */
export type BonusQuestionType = "campeao" | "vice_campeao" | "terceiro_colocado" | "rebaixado";

export const BONUS_QUESTION_CATALOG: Record<BonusQuestionType, { label: string; helpText: string }> = {
  campeao: { label: "Quem será o campeão?", helpText: "1º colocado na classificação final" },
  vice_campeao: { label: "Quem será o vice-campeão?", helpText: "2º colocado na classificação final" },
  terceiro_colocado: { label: "Quem será o terceiro colocado?", helpText: "3º colocado na classificação final" },
  rebaixado: { label: "Quem será rebaixado (último colocado)?", helpText: "Último colocado na classificação final" },
};

export const BONUS_QUESTION_ORDER: BonusQuestionType[] = ["campeao", "vice_campeao", "terceiro_colocado", "rebaixado"];

export interface BonusQuestionSetting {
  active: boolean;
  pontos: number;
}

/** Config da liga inteira — um doc único (não um por pergunta), já que o
 * prazo é compartilhado entre todas as perguntas ativas. */
export interface BonusQuestionsConfig {
  deadline: string | null; // ISO — null enquanto o ADM não define
  questions: Record<BonusQuestionType, BonusQuestionSetting>;
  /** true depois que o cron aplicou a pontuação final (campeonato encerrado). */
  scored: boolean;
  scoredAt: string | null;
  /** Preenchido junto com `scored` — o resultado real usado pra conferir. */
  finalResult: Partial<Record<BonusQuestionType, string>> | null; // clubId
}

export function hasAnyActiveQuestion(config: BonusQuestionsConfig | null | undefined): boolean {
  if (!config) return false;
  return BONUS_QUESTION_ORDER.some((t) => config.questions[t]?.active);
}

export function isDeadlinePassed(config: BonusQuestionsConfig | null | undefined): boolean {
  if (!config?.deadline) return false;
  return new Date(config.deadline).getTime() <= Date.now();
}

/** Resposta de UM participante — um doc por uid, com as respostas das
 * perguntas ativas (clubId escolhido). */
export interface BonusAnswer {
  uid: string;
  answers: Partial<Record<BonusQuestionType, string>>; // clubId por pergunta
  updatedAt: string;
}
